import { Injectable } from '@angular/core';
import { Subject} from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { Notificacao } from './notificacao';
export class NotificacaoService {
private _notificacoes: Subject<Notificacao> = new Subject<Notificacao>();
public notificacaoAdicionada = this._notificacoes.asObservable();
constructor() { }
/**
 * @param {?} notificacao
 * @return {?}
 */
public adicionar(notificacao: Notificacao) {
    this._notificacoes.next(notificacao);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NotificacaoService_tsickle_Closure_declarations() {
/** @type {?} */
NotificacaoService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NotificacaoService.ctorParameters;
/** @type {?} */
NotificacaoService.prototype._notificacoes;
/** @type {?} */
NotificacaoService.prototype.notificacaoAdicionada;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
